import { render, staticRenderFns } from "./Opdracht.vue?vue&type=template&id=446e6426"
import script from "./Opdracht.vue?vue&type=script&lang=js"
export * from "./Opdracht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports